export default __webpack_public_path__ + "static/Capture-1421eeecdcc70867c312e5420aef5a26.jpg";